// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type WorkbooksAnalyticsQueryVariables = PrivateSchemaTypes.Exact<{
  filter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
}>;


export type WorkbooksAnalyticsQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { workbooks: (
      { __typename?: 'AnalyticsWorkbooksModel' }
      & Pick<PrivateSchemaTypes.AnalyticsWorkbooksModel, 'completedCount' | 'inProgressCount' | 'notStartedCount' | 'overdueCount' | 'workbooksCount'>
    ) }
  ) }
);

export type ArchiveWorkbookMutationVariables = PrivateSchemaTypes.Exact<{
  workbookId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
}>;


export type ArchiveWorkbookMutation = (
  { __typename?: 'Mutation' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { workbooks: (
      { __typename?: 'AnalyticsWorkbooksModel' }
      & { topicEnrolment?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicEnrolmentModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsEditor, 'archive'>
      )> }
    ) }
  ) }
);

export type WorkbooksOverviewQueryVariables = PrivateSchemaTypes.Exact<{
  mainAnalyticsFilter: PrivateSchemaTypes.AnalyticsFilterWithGroups;
  workbooksOverviewFilter: PrivateSchemaTypes.AnalyticsWorkbooksFilter;
}>;


export type WorkbooksOverviewQuery = (
  { __typename?: 'Query' }
  & { analytics: (
    { __typename?: 'AnalyticsModel' }
    & { workbooks: (
      { __typename?: 'AnalyticsWorkbooksModel' }
      & Pick<PrivateSchemaTypes.AnalyticsWorkbooksModel, 'workbooksCount'>
      & { workbooksOverview: Array<(
        { __typename?: 'AnalyticsWorkbooksOverviewModel' }
        & Pick<PrivateSchemaTypes.AnalyticsWorkbooksOverviewModel, 'resourceName'>
        & { enrolment: (
          { __typename?: 'TopicEnrolmentModelAsEditor' }
          & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsEditor, 'id' | 'start_date' | 'completion_date' | 'target_completion_date' | 'share_batch_ts' | 'pass_mark' | 'auto_correct' | 'deleted_at' | 'progress' | 'status' | 'available_points' | 'attempt' | 'progress_time'>
          & { user: (
            { __typename?: 'UserModel' }
            & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name' | 'image_url'>
          ), topic: (
            { __typename?: 'TopicModel' }
            & Pick<PrivateSchemaTypes.TopicModel, 'id'>
          ), topicVersion?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'TopicVersionModel' }
            & Pick<PrivateSchemaTypes.TopicVersionModel, 'version' | 'max_attempts' | 'allow_retry' | 'topic_type'>
          )> }
        ) }
      )> }
    ) }
  ) }
);


export const WorkbooksAnalyticsDocument = gql`
    query WorkbooksAnalytics($filter: AnalyticsFilterWithGroups!) {
  analytics(filter: $filter) {
    workbooks {
      completedCount
      inProgressCount
      notStartedCount
      overdueCount
      workbooksCount
    }
  }
}
    `;

/**
 * __useWorkbooksAnalyticsQuery__
 *
 * To run a query within a React component, call `useWorkbooksAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbooksAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbooksAnalyticsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useWorkbooksAnalyticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkbooksAnalyticsQuery, WorkbooksAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkbooksAnalyticsQuery, WorkbooksAnalyticsQueryVariables>(WorkbooksAnalyticsDocument, options);
      }
export function useWorkbooksAnalyticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkbooksAnalyticsQuery, WorkbooksAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkbooksAnalyticsQuery, WorkbooksAnalyticsQueryVariables>(WorkbooksAnalyticsDocument, options);
        }
export type WorkbooksAnalyticsQueryHookResult = ReturnType<typeof useWorkbooksAnalyticsQuery>;
export type WorkbooksAnalyticsLazyQueryHookResult = ReturnType<typeof useWorkbooksAnalyticsLazyQuery>;
export type WorkbooksAnalyticsQueryResult = Apollo.QueryResult<WorkbooksAnalyticsQuery, WorkbooksAnalyticsQueryVariables>;
export const ArchiveWorkbookDocument = gql`
    mutation archiveWorkbook($workbookId: PositiveInt!, $filter: AnalyticsFilterWithGroups!) {
  analytics(filter: $filter) {
    workbooks {
      topicEnrolment(id: $workbookId) {
        archive
      }
    }
  }
}
    `;
export type ArchiveWorkbookMutationFn = Apollo.MutationFunction<ArchiveWorkbookMutation, ArchiveWorkbookMutationVariables>;

/**
 * __useArchiveWorkbookMutation__
 *
 * To run a mutation, you first call `useArchiveWorkbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkbookMutation, { data, loading, error }] = useArchiveWorkbookMutation({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useArchiveWorkbookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveWorkbookMutation, ArchiveWorkbookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveWorkbookMutation, ArchiveWorkbookMutationVariables>(ArchiveWorkbookDocument, options);
      }
export type ArchiveWorkbookMutationHookResult = ReturnType<typeof useArchiveWorkbookMutation>;
export type ArchiveWorkbookMutationResult = Apollo.MutationResult<ArchiveWorkbookMutation>;
export type ArchiveWorkbookMutationOptions = Apollo.BaseMutationOptions<ArchiveWorkbookMutation, ArchiveWorkbookMutationVariables>;
export const WorkbooksOverviewDocument = gql`
    query WorkbooksOverview($mainAnalyticsFilter: AnalyticsFilterWithGroups!, $workbooksOverviewFilter: AnalyticsWorkbooksFilter!) {
  analytics(filter: $mainAnalyticsFilter) {
    workbooks {
      workbooksOverview(overviewTableFilter: $workbooksOverviewFilter) {
        enrolment {
          id
          start_date
          completion_date
          target_completion_date
          share_batch_ts
          pass_mark
          auto_correct
          deleted_at
          progress
          status
          available_points
          attempt
          progress_time
          user {
            id
            display_name
            image_url
          }
          topic {
            id
          }
          topicVersion {
            version
            max_attempts
            allow_retry
            topic_type
          }
        }
        resourceName
      }
      workbooksCount(overviewTableFilter: $workbooksOverviewFilter)
    }
  }
}
    `;

/**
 * __useWorkbooksOverviewQuery__
 *
 * To run a query within a React component, call `useWorkbooksOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbooksOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbooksOverviewQuery({
 *   variables: {
 *      mainAnalyticsFilter: // value for 'mainAnalyticsFilter'
 *      workbooksOverviewFilter: // value for 'workbooksOverviewFilter'
 *   },
 * });
 */
export function useWorkbooksOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkbooksOverviewQuery, WorkbooksOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkbooksOverviewQuery, WorkbooksOverviewQueryVariables>(WorkbooksOverviewDocument, options);
      }
export function useWorkbooksOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkbooksOverviewQuery, WorkbooksOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkbooksOverviewQuery, WorkbooksOverviewQueryVariables>(WorkbooksOverviewDocument, options);
        }
export type WorkbooksOverviewQueryHookResult = ReturnType<typeof useWorkbooksOverviewQuery>;
export type WorkbooksOverviewLazyQueryHookResult = ReturnType<typeof useWorkbooksOverviewLazyQuery>;
export type WorkbooksOverviewQueryResult = Apollo.QueryResult<WorkbooksOverviewQuery, WorkbooksOverviewQueryVariables>;